// SEND-143 (Howard ruled 2026-08-28) — PHASE 2 LINEAR RUNS, ON SCREEN.
// Every trim row Howard named is here whether or not it can be measured.
//
// SEND-209 (Howard ruled 2026-08-14) — THE PHOTO HAS TO BE VISIBLE. This
// panel used to print the server's basis line, its refusal sentence and a
// sub-line per item, which turned seven trim rows into seven paragraphs and
// pushed the house off the screen. A ROW IS NOW ONE SHORT LINE: its name and
// its figure, or its name and the em dash. Nothing is hidden in the DOM —
// the paragraphs are not rendered at all.
//
// THE SERVER STILL WRITES EVERY SENTENCE. Not one refusal moved, not one
// basis was deleted, and no figure changed: the rail simply stopped printing
// the essay. The em dash is still the ONLY thing a missing figure may print.
import React from "react";

import { GABLE } from "./marks";

const lf = (v) => (v == null ? "—" : `${v} LF`);

export const TrimPanel = ({ qty }) => {
  const rows = qty?.trim_rows || [];
  return (
    <div className="p-3 border-b border-[var(--border)]" data-testid="photo-takeoff-trim-panel">
      <div className="text-[10px] uppercase tracking-wider font-bold text-[var(--muted)] mb-1">
        Linear runs — confirmed marks only
      </div>
      <div className="flex flex-col">
        {rows.map((r) => (
          <React.Fragment key={r.key}>
            <div
              className="flex items-baseline gap-2 text-[11px] py-0.5"
              data-testid={`photo-takeoff-trim-row-${r.key}`}>
              <span className="flex-1 truncate">
                {r.label}
                {r.zone === "gable" && (
                  <span className="ml-1 text-[9px] font-bold uppercase tracking-wider" style={{ color: GABLE }}>gable</span>
                )}
              </span>
              <span className="font-bold text-right" data-testid={`photo-takeoff-trim-lf-${r.key}`}>{lf(r.lf)}</span>
            </div>
            {/* SEND-309 — the trim board's per-width split, in its two coil
                buckets. Only widths with confirmed feet show; each names the
                coil its match lands on. Rendered ONLY for the band_board row. */}
            {r.key === "band_board" && (r.split || r.no_pick) && (
              <div className="pl-3 mt-0.5 mb-1 border-l-2 border-[var(--border)]" data-testid="photo-takeoff-trim-board-split">
                {(r.split || []).map((b) => (
                  <div key={b.key} className="mb-0.5" data-testid={`photo-takeoff-band-bucket-${b.key}`}>
                    <div className="flex items-baseline gap-2 text-[10px] font-bold text-[var(--ink-2)]">
                      <span className="flex-1 truncate">{b.label}</span>
                      <span className="text-right" data-testid={`photo-takeoff-band-bucket-lf-${b.key}`}>{lf(b.lf)}</span>
                    </div>
                    {b.entries.map((e) => (
                      <div
                        key={`${e.width}-${e.match}`}
                        className="flex items-baseline gap-2 text-[10px] text-[var(--muted)] pl-2"
                        data-testid={`photo-takeoff-band-width-${b.key}-${e.width}-${e.match}`}>
                        <span className="flex-1 truncate">{e.width}″ · match {e.match} → {e.coil}</span>
                        <span className="text-right">{lf(e.lf)}</span>
                      </div>
                    ))}
                  </div>
                ))}
                {r.no_pick && (
                  <div
                    className="flex items-baseline gap-2 text-[10px] text-[var(--muted)] italic"
                    data-testid="photo-takeoff-band-no-pick">
                    <span className="flex-1 truncate">No width/match — fills nothing</span>
                    <span className="text-right">{lf(r.no_pick.lf)}</span>
                  </div>
                )}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default TrimPanel;
